module.exports = __webpack_public_path__ + "img/icon-custom-switch-dark.ab51dde8.svg";